export const stripAmountFormatting = (value) =>
  String(value ?? "").replace(/,/g, "");

export const parseNumber = (value) => {
  const normalized = String(value ?? "")
    .replace(/,/g, "")
    .trim();

  const number = Number(normalized);

  return Number.isFinite(number) ? number : 0;
};

export const formatAmountInput = (value) => {
  const stripped = stripAmountFormatting(value).replace(/[^\d.]/g, "");

  if (!stripped) {
    return "";
  }

  const dotIndex = stripped.indexOf(".");
  const intRaw = dotIndex === -1 ? stripped : stripped.slice(0, dotIndex);
  const decRaw =
    dotIndex === -1 ? "" : stripped.slice(dotIndex + 1).replace(/\./g, "");

  const intDigits = intRaw.replace(/\D/g, "");
  const decDigits = decRaw.replace(/\D/g, "").slice(0, 2);

  const formattedInt = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (dotIndex !== -1) {
    return decDigits.length > 0
      ? `${formattedInt}.${decDigits}`
      : `${formattedInt}.`;
  }

  return formattedInt;
};

export const formatAmountDisplay = (value) => {
  const n = parseNumber(value);
  const normalized = (Math.round(n * 100) / 100).toFixed(2);

  return formatAmountInput(normalized);
};